import React from 'react'
import {Swiper, SwiperSlide} from 'swiper/react'

import styles from './styles.module.scss'
import {jobSlider} from '../../../../routes/jobSlider'
import {Autoplay, Navigation} from 'swiper'
import './style.css'
import {mainInformation} from "../../../../routes";
import parse from 'html-react-parser'

const JobsSlider = ({vacationInfo, info}) => {
	let vacationInfoReal = vacationInfo ? vacationInfo : info
	let _advantage = vacationInfoReal?.adventage
	if (_advantage == undefined || _advantage.length == 0) return ""
	return (
		<div className={styles.wrapper}>
			<div className={styles.right_wrapper}>
				<p className={styles.title}>Всё для уверенной карьеры</p>
				<p className={styles.text}>
					В Generium вы сможете полностью сосредоточиться на профессиональных <br/> достижениях. Мы создаем
					для
					этого благоприятную среду.
				</p>
			</div>

			<div className={styles.slider+' slider'}>
				<Swiper
					// pagination={true}
					spaceBetween={16}
					slidesPerView={3}
					initialSlide={0}
					loop={true}
					// speed={5000}
					// autoplay={{
					// 	delay: 3000
					// }}
					slideToClickedSlide
					navigation
					modules={[Navigation]}
					breakpoints={{
						1440: {
							slidesPerView: 3
						},
						1365: {
							slidesPerView: 3
						},
						900: {
							slidesPerView: 2.3,
							spaceBetween: 24
						},
						769: {
							slidesPerView: 1.5,
							spaceBetween: 16
						},
						686: {
							slidesPerView: 3,
							spaceBetween: 16
						},
						480: {
							slidesPerView: 2,
							spaceBetween: 16
						},
						380: {
							slidesPerView: 1.5,
							spaceBetween: 16
						},
						320: {
							slidesPerView: 1.3,
							spaceBetween: 16
						}
					}}
				>
					{_advantage !== undefined ?
						_advantage
							.filter((elem, i) => i < 8)
							.map((item, index) => (
								<>
									<SwiperSlide key={item.id}>
										<div className={styles.slider_item}>
											<p className={styles.slider_item_p1}>{item.adventageName}</p>
											<img src={item.adventageSVG} alt='icons' draggable='false'/>
											<p className={styles.slider_item_p2}>{parse(item.adventageDesc)}</p>
										</div>
									</SwiperSlide></>
							)) : ""}
				</Swiper>
			</div>
		</div>
	)
}


// <div className={styles.wrapper_down}>
//   {_advantages_city!==undefined ?
//     _advantages_city
//       .filter((elem, i) => i < 8)
//       .map((item, index) => (
//         <>
//           <div key={index} className={styles.wrapper_down_item}>
//             <img src={_advantages[index].adventageSVG} alt='icon' draggable='false'/>
//             <div>
//               <p className={styles.wrapper_down_item_p1}>{_advantages[index].adventageName}</p>
//               <p className={styles.wrapper_down_item_p2}>{_advantages[index].adventageDesc}</p>
//             </div>
//           </div>
//         </>)
//       ) : ""}
// </div>
export default JobsSlider
